module.exports = __webpack_public_path__ + "img/7.b9c2600c.png";